import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          d: "M19.8097 11.9516L17.8477 11.5635C17.9474 11.0594 18 10.5368 18 10C18 9.46316 17.9474 8.94058 17.8477 8.43652L19.8097 8.04838C19.9345 8.67958 20 9.33215 20 10C20 10.6679 19.9345 11.3204 19.8097 11.9516Z",
        }),
        _createElementVNode("path", {
          d: "M18.3157 4.44384L16.6537 5.55648C16.0691 4.68321 15.3168 3.93092 14.4435 3.34628L15.5562 1.68435C16.6467 2.41443 17.5856 3.35333 18.3157 4.44384Z",
        }),
        _createElementVNode("path", {
          d: "M11.9516 0.19034L11.5635 2.15232C11.0594 2.0526 10.5368 2 10 2C9.46316 2 8.94058 2.0526 8.43652 2.15232L8.04838 0.19034C8.67958 0.0654694 9.33215 0 10 0C10.6679 0 11.3204 0.0654694 11.9516 0.19034Z",
        }),
        _createElementVNode("path", {
          d: "M4.44384 1.68435L5.55648 3.34628C4.68321 3.93093 3.93092 4.68321 3.34628 5.55648L1.68435 4.44384C2.41443 3.35333 3.35333 2.41443 4.44384 1.68435Z",
        }),
        _createElementVNode("path", {
          d: "M0.19034 8.04838C0.0654694 8.67958 0 9.33215 0 10C0 10.6679 0.0654694 11.3204 0.190341 11.9516L2.15232 11.5635C2.0526 11.0594 2 10.5368 2 10C2 9.46316 2.0526 8.94058 2.15232 8.43652L0.19034 8.04838Z",
        }),
        _createElementVNode("path", {
          d: "M1.68435 15.5562L3.34628 14.4435C3.93093 15.3168 4.68321 16.0691 5.55648 16.6537L4.44384 18.3157C3.35333 17.5856 2.41443 16.6467 1.68435 15.5562Z",
        }),
        _createElementVNode("path", {
          d: "M8.04838 19.8097L8.43652 17.8477C8.94058 17.9474 9.46316 18 10 18C10.5368 18 11.0594 17.9474 11.5635 17.8477L11.9516 19.8097C11.3204 19.9345 10.6679 20 10 20C9.33215 20 8.67958 19.9345 8.04838 19.8097Z",
        }),
        _createElementVNode("path", {
          d: "M15.5562 18.3157L14.4435 16.6537C15.3168 16.0691 16.0691 15.3168 16.6537 14.4435L18.3157 15.5562C17.5856 16.6467 16.6467 17.5856 15.5562 18.3157Z",
        }),
        _createElementVNode("path", {
          d: "M14.5 9.13398C15.1667 9.51888 15.1667 10.4811 14.5 10.866L8.5 14.3301C7.83333 14.715 7 14.2339 7 13.4641L7 6.5359C7 5.7661 7.83333 5.28497 8.5 5.66987L14.5 9.13398Z",
        }),
      ],
    )
  );
}
